/**
 * useWindowSize Hook
 *
 * Returns current window dimensions and updates on resize.
 * Used for responsive component behavior (e.g., mobile vs desktop layouts).
 */

import { useState, useEffect } from 'react';

export function useWindowSize() {
  const [size, setSize] = useState<{ width: number | undefined; height: number | undefined }>({
    width: typeof window !== 'undefined' ? window.innerWidth : undefined,
    height: typeof window !== 'undefined' ? window.innerHeight : undefined,
  });

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return size;
}
